import { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useRoutes, navigate } from 'hookrouter';
import Routes from '../routes/routes';
import {
  FormControlLabel,
  Typography,
  Dialog,
  DialogContent,
  CircularProgress,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import RemoveIcon from '@material-ui/icons/Remove';
import AddIcon from '@material-ui/icons/Add';
import { v4 as uuidv4 } from 'uuid';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import Checkbox from '@material-ui/core/Checkbox';
import { useDispatch, useSelector } from 'react-redux';
import {
  createTemplateId,
  setCreateTemplateSelector,
  setNewTemplateIdSelector,
  addTemplate,
  setTypeSelector,
  getTemplateTypes,
  setalltemplatesSelector,
  setAttributeSelector,
  setTemplateAttributes,
  resetTemplateStates,
} from '../../services/templateSlice';
import CreateIcon from '@material-ui/icons/Create';
import NavBar from '../NavBar/navbar';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { getExisitingTemplates, setUploadSelector } from '../../services/uploadSlice';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import axios from 'axios';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    '& .MuiFormControl-root': {
      width: '100%',
      margin: theme.spacing(1),
      textAlign: 'left',
    },
  },
  outer: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: theme.spacing(5),
    padding: theme.spacing(2),
    '& > *': {
      margin: theme.spacing(1),
      width: '100%',
      height: '100%',
    },
    bullet: {
      display: 'inline-block',
      margin: '0 2px',
      transform: 'scale(0.8)',
    },
    pos: {
      marginBottom: 12,
    },
    textfield: {
      '& .MuiTextField-root': {
        margin: theme.spacing(1),
        width: '25ch',
      },
    },
    gridpaper: {
      padding: theme.spacing(2),
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
    fieldpos: {
      fontSize: '20px',
    },
    btnNavigate: {
      marginLeft: '25px',
      textAlign: 'left',
    },
  },
}));

export default function TemplateBuilder() {
  const dispatch = useDispatch();

  const templateIdResponse = useSelector(setNewTemplateIdSelector);
  const templateResponse = useSelector(setCreateTemplateSelector);
  const uploadResponse = useSelector(setUploadSelector);
  const typesResponse = useSelector(setTypeSelector);
  const fetchTemplateResponse = useSelector(setalltemplatesSelector);
  const setAttributesResponse = useSelector(setAttributeSelector);
  const [hasSnacks, sethasSnacks] = useState(false);
  const [moderator, setmoderator] = useState(false);
  const [templateLoader, settemplateLoader] = useState(false);

  const [hastemplates, sethastemplates] = useState(false);
  const [templateName, settemplateName] = useState('');
  const [templates, settemplates] = useState([]);
  const [versionName, setversionName] = useState('');
  const [datatypes, setdatatypes] = useState([]);
  const [modifiedTemplateID, setmodifiedTemplateID] = useState('');
  const [customerID, setcustomerID] = useState('');
  const Swal = require('sweetalert2');
  const [modifedversionname, setmodifedversionname] = useState('');
  const [isExisting, setisExisting] = useState(false);
  const api = '/api/';
  const [tempFields, setTempFields] = useState([
    { id: uuidv4(), question: '', type: 'Text', isMany: false, isSearchable: false },
  ]);
  const [existingtempFields, setexistingtempFields] = useState([]);
  const [loading, setloading] = useState(false);

  useEffect(() => {
    if (typesResponse.length !== 0) {
      setdatatypes(typesResponse);
    }
  }, [typesResponse]);

  useEffect(() => {
    if (existingtempFields.length !== 0) {
      settemplateLoader(false);
    }
  }, [existingtempFields]);

  const Alert = (props) => {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  };

  const fetchDetails = () => {
    let timeHandler = setInterval(() => {
      if ('uploads' in localStorage) {
        let current = [];
        let uploads = JSON.parse(localStorage.getItem('uploads'));
        for (let i = 0; i < uploads.length; i++) {
          current.push(uploads[i]);
        }
        if (current.length !== 0) {
          for (let i = 0; i < current.length; i++) {
            console.log('here');
            axios
              .get(api + 'uploadprogress/' + current[i])
              .then((response) => {
                let jsonResponse = response.data;
                if (jsonResponse.status === 'Completed') {
                  console.log('Open snack');
                  let msg = 'Upload of ' + unescape(jsonResponse.filename) + ' completed';
                  localStorage.setItem(
                    'snack',
                    JSON.stringify({
                      msg: msg,
                      tempid: jsonResponse.template.id,
                    }),
                  );
                  // setsnackMessage(msg);
                  // setsnackTemplate(jsonResponse.template.id);
                  sethasSnacks(true);
                  console.log('Done');
                  current.splice(i, 1);
                  console.log(current);
                  if (current.length != 0) {
                    localStorage.setItem('uploads', JSON.stringify(current));
                  } else {
                    localStorage.removeItem('uploads');
                  }
                }
              })
              .catch((error) => {
                console.log('Fetch data error');
                console.log(error);
              });
          }
        } else {
          localStorage.removeItem('uploads');
        }
      }
    }, 10000);

    localStorage.setItem('uploadTimeHandler', timeHandler);
  };

  useEffect(() => {
    if (moderator === true) {
      console.log('Changes detected');
      sethasSnacks(true);
      setmoderator(false);
    }
  }, [moderator]);

  useEffect(() => {
    settemplates([]);
    if (uploadResponse.length !== 0) {
      settemplates(uploadResponse);
      sethastemplates(true);
    }
  }, [uploadResponse]);

  useEffect(() => {
    if (setAttributesResponse.length !== 0) {
      let fields = [];
      setAttributesResponse.map((res) =>
        fields.push({
          id: uuidv4(),
          question: res.name,
          type: res.type.id,
          isMany: res.isMany,
          isSearchable: res.isSearchable,
        }),
      );
      setexistingtempFields(fields);
    }
  }, [setAttributesResponse]);

  useEffect(() => {
    setcustomerID(parseInt(localStorage.getItem('userId')));
    if (localStorage.getItem('auth') !== 'true') {
      navigate('/', true);
    }
    dispatch(getTemplateTypes());
    dispatch(getExisitingTemplates(parseInt(localStorage.getItem('userId'))));

    if ('uploadTimeHandler' in localStorage) {
      clearInterval(localStorage.getItem('uploadTimeHandler'));
      localStorage.removeItem('uploadTimeHandler');
    }

    if ('uploads' in localStorage) {
      let current = [];
      let uploads = JSON.parse(localStorage.getItem('uploads'));
      for (let i = 0; i < uploads.length; i++) {
        current.push(uploads[i]);
      }
      if (current.length !== 0) {
        for (let i = 0; i < current.length; i++) {
          console.log('here');
          axios
            .get(api + 'uploadprogress/' + current[i])
            .then((response) => {
              let jsonResponse = response.data;
              if (jsonResponse.status === 'Completed') {
                console.log('Open snack');
                let msg = 'Upload of ' + unescape(jsonResponse.filename) + ' completed';
                localStorage.setItem(
                  'snack',
                  JSON.stringify({
                    msg: msg,
                    tempid: jsonResponse.template.id,
                  }),
                );
                // setsnackMessage(msg);
                // setsnackTemplate(jsonResponse.template.id);
                setmoderator(true);
                console.log('Done');
                current.splice(i, 1);
                console.log(current);
                if (current.length != 0) {
                  localStorage.setItem('uploads', JSON.stringify(current));
                } else {
                  localStorage.removeItem('uploads');
                }
              }
            })
            .catch((error) => {
              console.log('Fetch data error');
              console.log(error);
            });
        }
      } else {
        localStorage.removeItem('uploads');
      }
    }
    setmoderator(false);
    fetchDetails();
    return;
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (templateName !== '' && versionName !== '') {
      setloading(true);
      initiateSubmit(tempFields, templateName, versionName);
    } else {
      console.log('Incomplete details');
    }
  };

  const handleModify = (e) => {
    e.preventDefault();
    setisExisting(true);
    if (templateName !== '' && modifedversionname !== '') {
      setloading(true);
      initiateSubmit(existingtempFields, templateName, modifedversionname);
    } else {
      console.log('Incomplete details');
    }
  };

  const initiateSubmit = (tempFields, templateName, versionName) => {
    let data = {
      name: templateName,
      version: versionName,
      customer: customerID,
      createdBy: localStorage.getItem('username'),
    };
    if (localStorage.getItem('auth') !== 'true') {
      navigate('/', true);
    }
    dispatch(createTemplateId(data));
    setloading(false);
  };

  useEffect(() => {
    if (templateIdResponse !== '') {
      if (isExisting) {
        createTemplate(existingtempFields, templateIdResponse);
        setisExisting(false);
      } else createTemplate(tempFields, templateIdResponse);
    }
  }, [templateIdResponse]);

  const createTemplate = (tempFields, id) => {
    let data = [];
    console.log(tempFields);
    setloading(true);

    tempFields.map((entry) =>
      data.push({
        name: entry.question,
        template: id,
        type: entry.type,
        isSearchable: entry.isSearchable,
        isMany: entry.isMany,
        order: 0,
      }),
    );
    console.log(data);
    dispatch(addTemplate(data));
    setloading(false);
  };

  useEffect(() => {
    if (templateResponse.length !== 0) {
      Swal.fire({
        text: 'Template created successfully',
        icon: 'success',
      }).then((result) => {
        setexistingtempFields([]);
        settemplateName('');

        setTempFields([
          { id: uuidv4(), question: '', type: 'Text', isMany: false, isSearchable: false },
        ]);
        dispatch(resetTemplateStates());
      });
    }
  }, [templateResponse]);

  const handleChangeInput = (id, event) => {
    const newTempFields = tempFields.map((i) => {
      if (event.target.name === 'isMany' && id === i.id) {
        i['isMany'] = event.target.checked;
      } else if (event.target.name === 'isSearchable' && id === i.id) {
        i['isSearchable'] = event.target.checked;
      } else if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setTempFields(newTempFields);
  };

  const handleChangeInputForExisting = (id, event) => {
    const newTempFields = existingtempFields.map((i) => {
      if (event.target.name === 'isMany' && id === i.id) {
        i['isMany'] = event.target.checked;
      } else if (event.target.name === 'isSearchable' && id === i.id) {
        i['isSearchable'] = event.target.checked;
      } else if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setexistingtempFields(newTempFields);
  };

  const handleClose = (event, reason) => {
    let id = JSON.parse(localStorage.getItem('snack'))['tempid'];
    sethasSnacks(false);
    // setsnackTemplate('');
    // setsnackMessage('');
    localStorage.removeItem('snack');
    navigate('/uploads/' + id);
  };

  const handleExit = (e, reason) => {
    sethasSnacks(false);
    localStorage.removeItem('snack');

    // setsnackTemplate('');
    // setsnackMessage('');
  };

  const handleAddFields = () => {
    setTempFields([
      ...tempFields,
      { id: uuidv4(), question: '', type: 'Text', isMany: false, isSearchable: false },
    ]);
  };

  const handleAddFieldsForExisting = () => {
    setexistingtempFields([
      ...existingtempFields,
      { id: uuidv4(), question: '', type: 'Text', isMany: false, isSearchable: false },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...tempFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1,
    );
    setTempFields(values);
  };

  const handleRemoveFieldsForExisting = (id) => {
    const values = [...existingtempFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1,
    );
    setexistingtempFields(values);
  };

  const fetchDetailsforModification = (modifiedTemplateID) => {
    if (localStorage.getItem('auth') !== 'true') {
      navigate('/', true);
    }
    settemplateLoader(true);
    dispatch(setTemplateAttributes(modifiedTemplateID));
  };

  const classes = useStyles();
  const [formchoice, setchoice] = useState('Create New Template');
  useRoutes(Routes);
  if (localStorage.getItem('auth') !== 'true') {
    navigate('/', true);
  }
  return (
    <>
      <NavBar />

      <Box className={classes.outer} boxShadow={5}>
        <form autoComplete="off" className={classes.root}>
          <div style={{ margin: '10px' }}>
            <Button
              variant="outlined"
              startIcon={<VisibilityIcon />}
              color="default"
              onClick={() => navigate('/template/' + localStorage.getItem('userId'))}
            >
              View Existing Templates
            </Button>
          </div>
          <div style={{ textAlign: 'center', margin: '20px' }}>
            <Typography variant="h6">Template creation</Typography>
            {!hastemplates && (
              <>
                <br></br>
                <Typography variant="h8">This customer has no previous templates</Typography>
              </>
            )}
          </div>
          {formchoice === 'Create New Template' && (
            <Grid container spacing={3}>
              <Grid item md={4} sm={12} xs={12}></Grid>
              <Grid item md={4} sm={12} xs={12}></Grid>
              <Grid item md={4} sm={12} xs={12}></Grid>
              <Grid item md={4} sm={12} xs={12}>
                {hastemplates === true && (
                  <TextField
                    select
                    id="type-selector"
                    variant="outlined"
                    defaultValue="Create New Template"
                    onChange={(e) => {
                      setchoice(e.target.value);
                    }}
                  >
                    <MenuItem value="Create New Template">Create New Template</MenuItem>
                    <MenuItem value="Use Existing Template">Use Existing Template</MenuItem>
                  </TextField>
                )}

                {hastemplates === false && (
                  <TextField
                    select
                    id="type-selector"
                    variant="outlined"
                    defaultValue="Create New Template"
                    onChange={(e) => {
                      setchoice(e.target.value);
                    }}
                  >
                    <MenuItem value="Create New Template">Create New Template</MenuItem>
                  </TextField>
                )}

                {/* <TextField 
                        select
                        id="type-selector"
                        variant="outlined"
                        defaultValue="Create New Template"
                        onChange={(e) => {
                            setchoice(e.target.value)
                        }}
                    >
                    <MenuItem value="Create New Template">Create New Template</MenuItem>
                    {(hastemplates) && <MenuItem value="Use Existing Template">Use Existing Template</MenuItem>}
                    </TextField> */}
              </Grid>
              <Grid item md={4} sm={12} xs={12}>
                <TextField
                  id="template-name"
                  onChange={(e) => {
                    settemplateName(e.target.value);
                  }}
                  label="Template Name"
                  variant="outlined"
                />
              </Grid>
              <Grid item md={4} sm={12} xs={12}>
                <TextField
                  id="template-version"
                  onChange={(e) => {
                    setversionName(e.target.value);
                  }}
                  label="Template Version Name"
                  variant="outlined"
                />
              </Grid>
            </Grid>
          )}

          {formchoice === 'Use Existing Template' && (
            <Grid container spacing={4}>
              <Grid item md={3} sm={12} xs={12}>
                {hastemplates === true && (
                  <TextField
                    select
                    id="type-selector"
                    variant="outlined"
                    defaultValue="Use Existing Template"
                    onChange={(e) => {
                      setchoice(e.target.value);
                    }}
                  >
                    <MenuItem value="Create New Template">Create New Template</MenuItem>
                    <MenuItem value="Use Existing Template">Use Existing Template</MenuItem>
                  </TextField>
                )}

                {hastemplates === false && (
                  <TextField
                    select
                    id="type-selector"
                    variant="outlined"
                    defaultValue="Use Existing Template"
                    onChange={(e) => {
                      setchoice(e.target.value);
                    }}
                  >
                    <MenuItem value="Create New Template">Create New Template</MenuItem>
                  </TextField>
                )}

                {/* <TextField 
                        select
                        id="type-selector"
                        variant="outlined"
                        defaultValue="Use Existing Template"
                        onChange={(e) => {
                            setchoice(e.target.value)
                        }}
                    >
                    <MenuItem value="Create New Template">Create New Template</MenuItem>
                    <MenuItem value="Use Existing Template">Use Existing Template</MenuItem>
                    </TextField> */}
              </Grid>
              <Grid item md={3} sm={12} xs={12}>
                <TextField
                  select
                  id="template-selector"
                  placeholder="Select template and version"
                  label="Select Template"
                  variant="outlined"
                  onChange={(e) => {
                    setmodifiedTemplateID(e.target.value);
                    fetchDetailsforModification(e.target.value);
                    settemplateName(
                      templates.filter((option) => option.template.id == e.target.value)[0]
                        ? templates.filter((option) => option.template.id == e.target.value)[0]
                          .template.name
                        : '',
                    );
                  }}
                >
                  {templates.map((template) => (
                    <MenuItem value={template.template.id}>
                      {template.template.name} - {template.template.version}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item md={3} sm={12} xs={12}>
                <TextField
                  id="template-name"
                  onChange={(e) => {
                    settemplateName(e.target.value);
                  }}
                  value={
                    templates.filter((option) => option.template.id == modifiedTemplateID)[0]
                      ? templates.filter((option) => option.template.id == modifiedTemplateID)[0]
                        .template.name
                      : ''
                  }
                  label="Template Name"
                  variant="outlined"
                />
              </Grid>
              <Grid item md={3} sm={12} xs={12}>
                <TextField
                  id="template-version-modified"
                  onChange={(e) => {
                    setmodifedversionname(e.target.value);
                  }}
                  label="Version Name"
                  variant="outlined"
                />
              </Grid>
            </Grid>
          )}
        </form>

        {formchoice === 'Create New Template' && (
          <Typography variant="h6" style={{ textAlign: 'center' }}>
            <br></br>
            Template Entities
            <br></br>
          </Typography>
        )}
        {/* Contents of the template*/}

        <br></br>
        {formchoice === 'Create New Template' && (
          <Container>
            <form className={classes.root} onSubmit={handleSubmit}>
              {tempFields.map((inputField) => (
                <div key={inputField.id}>
                  <Grid container spacing={6}>
                    <Grid item md={3} sm={12} xs={12}>
                      <TextField
                        name="question"
                        label="Form Name"
                        variant="outlined"
                        value={inputField.question}
                        onChange={(event) => handleChangeInput(inputField.id, event)}
                      />
                    </Grid>
                    <Grid item md={3} sm={12} xs={12}>
                      <TextField
                        select
                        name="type"
                        label="Type"
                        variant="outlined"
                        onChange={(event) => handleChangeInput(inputField.id, event)}
                      >
                        {datatypes &&
                          datatypes.map((type) => <MenuItem value={type.id}>{type.name}</MenuItem>)}
                      </TextField>
                    </Grid>
                    <Grid item md={1} sm={12} xs={12}>
                      {/* <FormControlLabel
                        style={{"marginTop":"15px"}}
                        control={
                            <Checkbox
                                onChange={event => handleChangeInput(inputField.id, event)}
                                name="isMany"
                                color="primary"
                            />
                        }
                        label="Has multiple values?"
                    /> */}
                    </Grid>
                    <Grid item md={3} sm={12} xs={12}>
                      <FormControlLabel
                        style={{ marginTop: '15px' }}
                        control={
                          <Checkbox
                            onChange={(event) => handleChangeInput(inputField.id, event)}
                            name="isSearchable"
                            color="primary"
                          />
                        }
                        label="Is searchable?"
                      />
                    </Grid>
                    <Grid item md={1} sm={12} xs={12}>
                      <IconButton
                        disabled={tempFields.length === 1}
                        onClick={() => handleRemoveFields(inputField.id)}
                        style={{ marginTop: '15px' }}
                      >
                        <RemoveIcon />
                      </IconButton>
                    </Grid>
                    <Grid item md={1} sm={12} xs={12}>
                      <IconButton onClick={handleAddFields} style={{ marginTop: '15px' }}>
                        <AddIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                </div>
              ))}
            </form>
            <div style={{ textAlign: 'center', marginTop: '50px', marginLeft: '100px' }}>
              <Button
                size="medium"
                color="primary"
                startIcon={<CreateIcon />}
                variant="outlined"
                type="submit"
                onClick={handleSubmit}
              >
                CREATE
              </Button>
            </div>
          </Container>
        )}

        {/* If modification */}
        {formchoice === 'Use Existing Template' &&
          modifiedTemplateID !== '' &&
          existingtempFields.length !== 0 && (
            <Typography variant="h6" style={{ textAlign: 'center' }}>
              <br></br>
              Template Entities
              <br></br>
            </Typography>
          )}

        {/* Contents of the template*/}

        <br></br>
        {formchoice === 'Use Existing Template' && (
          <>
            <Container>
              <form className={classes.root} onSubmit={handleModify}>
                {existingtempFields.map((inputField) => (
                  <div key={inputField.id}>
                    <Grid container spacing={6}>
                      <Grid item md={3} sm={12} xs={12}>
                        <TextField
                          name="question"
                          label="Form Name"
                          variant="outlined"
                          value={inputField.question}
                          onChange={(event) => handleChangeInputForExisting(inputField.id, event)}
                        />
                      </Grid>
                      <Grid item md={3} sm={12} xs={12}>
                        <TextField
                          select
                          name="type"
                          label="Type"
                          variant="outlined"
                          defaultValue={inputField.type}
                          onChange={(event) => handleChangeInputForExisting(inputField.id, event)}
                        >
                          {datatypes &&
                            datatypes.map((type) => (
                              <MenuItem value={type.id}>{type.name}</MenuItem>
                            ))}
                        </TextField>
                      </Grid>
                      <Grid item md={1} sm={12} xs={12}>
                        {/* <FormControlLabel
                    style={{"marginTop":"15px"}}
                    control={
                        <Checkbox
                            onChange={event => handleChangeInputForExisting(inputField.id, event)}
                            name="isMany"
                            color="primary"
                            defaultChecked={inputField.isMany}
                        />
                    }
                    label="Has multiple values?"
                /> */}
                      </Grid>
                      <Grid item md={3} sm={12} xs={12}>
                        <FormControlLabel
                          style={{ marginTop: '15px' }}
                          control={
                            <Checkbox
                              onChange={(event) =>
                                handleChangeInputForExisting(inputField.id, event)
                              }
                              name="isisSearchable"
                              color="primary"
                              defaultChecked={inputField.isSearchable}
                            />
                          }
                          label="Is searchable?"
                        />
                      </Grid>
                      <Grid item md={1} sm={12} xs={12}>
                        <IconButton
                          disabled={existingtempFields.length === 1}
                          onClick={() => handleRemoveFieldsForExisting(inputField.id)}
                          style={{ marginTop: '15px' }}
                        >
                          <RemoveIcon />
                        </IconButton>
                      </Grid>
                      <Grid item md={1} sm={12} xs={12}>
                        <IconButton
                          onClick={handleAddFieldsForExisting}
                          style={{ marginTop: '15px' }}
                        >
                          <AddIcon />
                        </IconButton>
                      </Grid>
                    </Grid>
                  </div>
                ))}
              </form>
              <div style={{ textAlign: 'center', marginTop: '50px', marginLeft: '100px' }}>
                {modifiedTemplateID !== '' && (
                  <Button
                    size="medium"
                    color="primary"
                    startIcon={<CreateIcon />}
                    variant="outlined"
                    type="submit"
                    onClick={handleModify}
                  >
                    CREATE
                  </Button>
                )}
              </div>
            </Container>

            <Dialog open={loading}>
              <DialogContent style={{ overflow: 'hidden', textAlign: 'center' }}>
                <CircularProgress />
                <Typography variant="h6">Processing</Typography>
              </DialogContent>
            </Dialog>
          </>
        )}
      </Box>
      {hasSnacks ? (
        <Snackbar key={new Date()} open={hasSnacks} autoHideDuration={6000} onClose={handleExit}>
          <Alert elevation={6} variant="filled" onClose={handleExit} severity="success">
            {hasSnacks ? JSON.parse(localStorage.getItem('snack'))['msg'] : ''}
            <Button size="small" onClick={handleClose}>
              OPEN
            </Button>
          </Alert>
        </Snackbar>
      ) : null}

      <Dialog open={templateLoader}>
        <DialogContent style={{ overflow: 'hidden', textAlign: 'center' }}>
          <CircularProgress />
          <Typography variant="h6">Fetching Template Details</Typography>
        </DialogContent>
      </Dialog>
    </>
  );
}
